export default {
  "dashboard.analysis.test": "Gongzhuan No.{no} shop",
  "dashboard.analysis.introduce": "Introduce",
  "dashboard.analysis.total-sales": "Total Active Shipments",
  "dashboard.analysis.day-sales": "Daily Sales",
  "dashboard.analysis.visits": "Visits",
  "dashboard.analysis.visits-trend": "Visits Trend",
  "dashboard.analysis.visits-ranking": "Visits Ranking",
  "dashboard.analysis.day-visits": "Daily Visits",
  "dashboard.analysis.week": "WoW Change",
  "dashboard.analysis.day": "DoD Change",
  "dashboard.analysis.payments": "Payments",
  "dashboard.analysis.conversion-rate": "Conversion Rate",
  "dashboard.analysis.operational-effect": "Operational Effect",
  "dashboard.analysis.sales-trend": "Stores Sales Trend",
  "dashboard.analysis.sales-ranking": "Sales Ranking",
  "dashboard.analysis.all-year": "All Year",
  "dashboard.analysis.all-month": "All Month",
  "dashboard.analysis.all-week": "All Week",
  "dashboard.analysis.all-day": "All day",
  "dashboard.analysis.search-users": "Search Users",
  "dashboard.analysis.per-capita-search": "Per Capita Search",
  "dashboard.analysis.online-top-search": "Online Top Search",
  "dashboard.analysis.the-proportion-of-sales": "The Proportion Of Sales",
  "dashboard.channel.all": "ALL",
  "dashboard.channel.online": "Online",
  "dashboard.channel.stores": "Stores",
  "dashboard.analysis.sales": "Sales",
  "dashboard.analysis.traffic": "Traffic",
  "dashboard.table.rank": "Rank",
  "dashboard.table.search-keyword": "Keyword",
  "dashboard.table.users": "Users",
  "dashboard.table.weekly-range": "Weekly Range",
};
